import { VisibilityOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  IconButton,
  Modal,
  Skeleton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import PlusIcon from '@untitled-ui/icons-react/build/esm/Plus';
import { format } from 'date-fns';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import Loader from 'src/components/LoaderImg/loader.gif';
import { paths } from 'src/paths';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import {
  getAllMiscDocumentAction,
  resetSaveMiscDocumentAction,
  resetUndoDocumentSignAction,
  saveMiscDocumentAction,
} from 'src/redux/actions/documentationAction';
import { Scrollbar } from '../scrollbar';
import useCurrentUser from 'src/hooks/use-current-user';
import SucessModal from '../sucess-modal';

function MiscellaneousDocuments({
  getAllMiscDocsResponse,
  openPrintMode,
  setMicDocuments,
  MicDocuments,
  onSelectAllClickMicDoc,
  setIsFilterApply,
}: any) {
  
  const dispatch = useDispatch();
  const fileRef = useRef<any>(null);
  const [providerId] = useCurrentUser(['providerId']);
  const saveMiscDocResponse = useSelector((state: any) => state.saveMiscellaneousDocumentsReducer);
  const { patients, patientDetails, episodeOfCare, details, previewDocument } = paths;
  const location = useLocation();
  const navigate = useNavigate();
  const chooseDocument = () => {
    fileRef.current.click();
  };
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);

  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    if(!firstRender) return;
    setFirstRender(false);

    if(location.hash === '#miscellaneous-documents-header') {
      const target = document.getElementById('miscellaneous-documents-header');

      if(!target) return;

      setTimeout(() => {
        const topNav = document.getElementById('top-nav');
        const elementTop = target.getBoundingClientRect().top + window.pageYOffset;
        const offset = topNav?.offsetHeight || 0;
        const scrollToY = Math.max(0, elementTop - offset);
        window.scrollTo({top: scrollToY});
      }, 500);
    }
  }, [firstRender, location.hash])

  const getMiscDocuments = () => {
    dispatch(
      getAllMiscDocumentAction({
        EocId: location?.state?.episodeOfCareId,
      })
    );
  };
  // THIN-7259: migrated from the legacy editSignDocumentReducer to the
  // FSM-aware undoDocumentSignReducer (the legacy path was a no-op BE-side
  // and dead-dispatched after THIN-7258).
  const undoDocumentSignResponse = useSelector((state: any) => state.undoDocumentSignReducer);
  useEffect(() => {
    if (!undoDocumentSignResponse.isSuccess && undoDocumentSignResponse.response === null) return;
    getMiscDocuments();
    dispatch(resetUndoDocumentSignAction());
  }, [undoDocumentSignResponse]);

  useEffect(() => {
    getMiscDocuments();
  }, []);

  const [IsCorrectFormat, setCorrectFormat] = useState(false);
  const closeModal = () => setCorrectFormat(false);
  const uploadFile = (e: any) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (selectedFile?.type !== 'application/pdf') {
          setCorrectFormat(true);
          e.target.value = null;
          return;
        }
        let formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('therapistId', typeof providerId === 'string' ? providerId : '');
        formData.append('episodeOfCareId', location?.state?.episodeOfCareId);
        formData.append('documentName', selectedFile?.name);
        dispatch(
          saveMiscDocumentAction({
            data: formData,
            param: {
              type: 'OTHER',
            },
          })
        );
        e.target.value = null;
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  useEffect(() => {
    if (!saveMiscDocResponse.isDocumentSave && saveMiscDocResponse.response === null) return;
    getMiscDocuments();
    dispatch(resetSaveMiscDocumentAction());
  }, [saveMiscDocResponse]);

  const setPreviewDocument = (document: any) => {
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${previewDocument}`, {
      state: {
        document,
        episodeOfCareId: location?.state?.episodeOfCareId,
        patientData,
      },
    });
  };
  const anchorRef = useRef<any>(null);
  const [popUpContent, setPopup] = useState(false);
  const handleClose = useCallback((event: Event): void => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setPopup(false);
  }, []);

  const handleAddMicPopUp = useCallback((): void => {
    setPopup((prevOpen) => !prevOpen);
  }, []);

  const handleNavigatePhysician = () => {
    navigate(`physician-sign-document`, {
      state: {
        episodeOfCareId: location?.state?.episodeOfCareId,
        patientData,
      },
    });
  };

  return (
    <>
      <Box
        sx={{
          boxShadow: '0px 5px 22px 0px rgba(0, 0, 0, 0.04), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.03)',
          borderRadius: '20px',
          background: '#FFF',
          height: 'auto',
        }}
      >
        <Card sx={{ padding: '1.5rem' }}>
          <Card>
            <Grid
              container
              sx={{ padding: '18px 24px 18px 24px', position: 'relative' }}
            >
              <Typography variant="h6"
                id="miscellaneous-documents-header">Miscellaneous Documents</Typography>
              <Box
                sx={{
                  border: '1px solid rgba(0, 0, 0, 0.26)',
                  borderRadius: '12px',
                  padding: '3px',
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '12px',
                }}
              >
                <Typography sx={{ color: '#111927', fontSize: '13px', letterSpacing: '0.16px' }}>
                  {!getAllMiscDocsResponse?.loading &&
                  getAllMiscDocsResponse?.response?.length === 0
                    ? `0 Document`
                    : `${getAllMiscDocsResponse?.response?.length} Document`}
                </Typography>

                {saveMiscDocResponse.loading ? (
                  <img
                    src={Loader}
                    alt="loading"
                    style={{ position: 'absolute', right: 0, padding: 10 }}
                  />
                ) : (
                  <Button
                    sx={{ position: 'absolute', right: 0 }}
                    // onClick={handleAddMicPopUp}
                    onClick={handleNavigatePhysician}
                    startIcon={
                      <SvgIcon>
                        <PlusIcon />
                      </SvgIcon>
                    }
                    // ref={anchorRef}
                  >
                    Attach New Document
                  </Button>
                )}

                {/* <input
                  type="file"
                  id="file"
                  accept="application/pdf"
                  ref={fileRef}
                  style={{ display: 'none' }}
                  onChange={(e) => uploadFile(e)}
                /> */}
              </Box>
            </Grid>
            {/* Table */}
            <Scrollbar>
              <Table sx={{ minWidth: 700 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      {openPrintMode ? (
                        <Checkbox
                          color="primary"
                          indeterminate={
                            MicDocuments?.length > 0 &&
                            MicDocuments?.length < getAllMiscDocsResponse?.response?.length
                          }
                          checked={
                            getAllMiscDocsResponse?.response?.length > 0 &&
                            MicDocuments?.length === getAllMiscDocsResponse?.response?.length
                          }
                          onChange={onSelectAllClickMicDoc}
                          inputProps={{
                            'aria-label': 'select all desserts',
                          }}
                        />
                      ) : null}{' '}
                      Document Name
                    </TableCell>
                    <TableCell>Date of Service</TableCell>
                    <TableCell>Uploaded By</TableCell>
                    <TableCell>Uploaded On</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAllMiscDocsResponse?.loading ? (
                    <TableRow>
                      <TableCell colSpan={6}>
                        <Box
                          textAlign="center"
                          p={3}
                        >
                          <Skeleton animation="wave" />
                          <Skeleton animation="wave" />
                          <Skeleton animation="wave" />
                          <Skeleton animation="wave" />
                          <Skeleton animation="wave" />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : getAllMiscDocsResponse?.response?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Box
                          textAlign="center"
                          p={3}
                        >
                          <Typography
                            color={'text.secondary'}
                            variant="subtitle2"
                          >
                            No Records Found
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    getAllMiscDocsResponse?.response?.map((document: any) => (
                      <TableRow
                        hover
                        key={document.uuid}
                        onClick={() => {
                          if (openPrintMode) {
                            setIsFilterApply(false);
                            const chipIndex = MicDocuments?.find(
                              (chip: any) => chip?.uuid === document?.uuid
                            );
                            if (chipIndex) {
                              const updatedChips = MicDocuments?.filter(
                                (chip: any) => chip?.uuid !== document?.uuid
                              );
                              setMicDocuments(updatedChips);
                              return;
                            } else {
                              setMicDocuments([...MicDocuments, document]);
                            }
                            return;
                          }
                        }}
                        sx={{
                          backgroundColor: MicDocuments?.some(
                            (item: any) => item?.uuid === document?.uuid
                          )
                            ? '#EBEEFE'
                            : null,
                        }}
                      >
                        <TableCell>
                          {' '}
                          {openPrintMode ? (
                            <Checkbox
                              checked={MicDocuments?.some(
                                (item: any) => item?.uuid === document?.uuid
                              )}
                            />
                          ) : null}{' '}
                          {document?.outDated ? (
                            <Tooltip
                              title="This signature needs to be re-done"
                              placement="top"
                            >
                              <IconButton
                                sx={{
                                  backgroundColor: '#FEE4E2',
                                  padding: '4px',
                                  mr: 1,
                                  '&:hover': {
                                    backgroundColor: '#FEE4E2',
                                  },
                                }}
                              >
                                <PriorityHighIcon sx={{ color: '#B42318', fontSize: '1rem' }} />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                          {document.documentName || '-'}
                        </TableCell>
                        <TableCell>
                          {document?.dateOfService
                            ? format(
                                new Date(
                                  new Date(document?.dateOfService).valueOf() +
                                    new Date(document?.dateOfService).getTimezoneOffset() *
                                      60 *
                                      1000
                                ),
                                'dd MMM, yyyy'
                              )
                            : '-'}
                        </TableCell>
                        <TableCell>{document.uploadedBy || '-'}</TableCell>
                        <TableCell>
                          {document.createdOn
                            ? format(
                                new Date(
                                  new Date(document.createdOn).valueOf() +
                                    new Date(document.createdOn).getTimezoneOffset() * 60 * 1000
                                ),
                                'dd MMM, yyyy'
                              )
                            : '-'}
                        </TableCell>
                        <TableCell>
                          {document?.type === 'PHYSICIAN_SIGNATURE'
                            ? 'Physician Signature'
                            : document?.type === 'SUPERVISOR_SIGNATURE'
                            ? 'Supervisor Signature'
                            : 'Other'}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => setPreviewDocument(document)}>
                            <VisibilityOutlined />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Scrollbar>
          </Card>
        </Card>
      </Box>

      <Modal open={IsCorrectFormat}>
        <SucessModal
          isSucess={false}
          close={closeModal}
          title="Incorrect Format"
          message="Please choose 'pdf' file to upload a miscellaneous document"
        />
      </Modal>
    </>
  );
}

export default MiscellaneousDocuments;
